import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { hasError:false, error:null }; }
  static getDerivedStateFromError(error){ return { hasError:true, error }; }
  componentDidCatch(error, info){ console.error("App crash:", error, info); }
  render(){
    if (this.state.hasError) {
      return (
        <div style={{minHeight:"60vh",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,boxShadow:"0 8px 18px rgba(0,0,0,0.08)",padding:24}}>
            <h1 style={{marginTop:0}}>Something went wrong</h1>
            <pre style={{whiteSpace:"pre-wrap"}}>{String(this.state.error)}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
